import React from "react";
import { string, bool } from "prop-types";

import I18n from "pages/_components/I18n";

const Stepper = ({ isMobile, page }) => {
    const fistStepPages = ["StepCUIT", "StepEmail", "StepSms", "StepSmsWithInvitation"];
    const secondStepPages = ["StepScanDocument", "StepCaptureSelfie"];
    const thirdStepPages = ["StepPersonalData", "StepRegulatoryData"];
    const fourthStepPages = ["StepUser", "StepPassword", "StepSelectSecuritySeal"];

    const firstStepPagesEnrolledUser = ["StepCUITEnrolledUser", "StepEmailEnrolledUser", "StepSmsEnrolledUser"];
    const secondStepPagesEnrolledUser = ["StepVerifyUsername", "StepVerifyPassword"];
    const thirdStepPagesEnrolledUser = ["StepSelectEnrolledUserRole"];

    let pagesEnrolledUser = false;
    let currentStep = 0;
    if (fistStepPages.includes(page)) {
        currentStep = 1;
    }
    if (secondStepPages.includes(page)) {
        currentStep = 2;
    }
    if (thirdStepPages.includes(page)) {
        currentStep = 3;
    }
    if (fourthStepPages.includes(page)) {
        currentStep = 4;
    }
    if (firstStepPagesEnrolledUser.includes(page)) {
        pagesEnrolledUser = true;
        currentStep = 1;
    }
    if (secondStepPagesEnrolledUser.includes(page)) {
        pagesEnrolledUser = true;
        currentStep = 2;
    }
    if (thirdStepPagesEnrolledUser.includes(page)) {
        pagesEnrolledUser = true;
        currentStep = 3;
    }

    const stepTitles = {
        0: "Error",
        1: "Permisos y verificación",
        2: "Datos biométricos",
        3: "Datos personales",
        4: "Creación de usuario y contraseña",
    };

    const stepTitlesEnrolledUser = {
        1: "Permisos y verificación",
        2: "Validación de credenciales",
        3: "Selección de rol",
    };

    const defaultColor = "#CED2E0";
    const activeColor = "#35EEC8";

    const mobileBoxStyle = {
        display: "flex",
        justifyContent: "space-between",
    };

    const mobileBarStyle = (numOfBar) => ({
        width: !pagesEnrolledUser ? "24%" : "33%",
        borderRadius: 6,
        height: 6,
        marginBottom: 10,
        backgroundColor: currentStep >= numOfBar ? activeColor : defaultColor,
    });

    return isMobile ? (
        <div className="stepper">
            <div style={mobileBoxStyle}>
                <div style={mobileBarStyle(1)} />
                <div style={mobileBarStyle(2)} />
                <div style={mobileBarStyle(3)} />
                {!pagesEnrolledUser && <div style={mobileBarStyle(4)} />}
            </div>
            <div>
                <I18n defaultValue="Paso" />
                {!pagesEnrolledUser && <span>{` ${currentStep}: ${stepTitles[currentStep]}`}</span>}
                {pagesEnrolledUser && <span>{` ${currentStep}: ${stepTitlesEnrolledUser[currentStep]}`}</span>}
            </div>
        </div>
    ) : null;
};

Stepper.propTypes = {
    isMobile: bool.isRequired,
    page: string.isRequired,
};

export default Stepper;
